import { Stories as Base } from "@cancer-council-queensland/react";
import { jsx as _jsx } from "react/jsx-runtime";
export var Stories = props => {
  var stories = (props.stories || []).map(story => {
    var _story$content;

    return story == null ? void 0 : (_story$content = story.content) == null ? void 0 : _story$content.meta;
  }).map(story => {
    return {
      title: story == null ? void 0 : story.title,
      content: story == null ? void 0 : story.description,
      image: story == null ? void 0 : story.og_image
    };
  });
  return /*#__PURE__*/_jsx(Base, {
    stories: stories,
    label: props.label
  });
};
//# sourceMappingURL=stories.js.map